import { render, staticRenderFns } from "./TeamCard.vue?vue&type=template&id=418c30dc&"
import script from "./TeamCard.vue?vue&type=script&lang=js&"
export * from "./TeamCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports